export default __webpack_public_path__ + "static/media/cresol-logo.6623bda9.png";